var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.897 7.10195L7.10195 10.897C6.61445 10.4095 6.31445 9.74195 6.31445 8.99945C6.31445 7.51445 7.51445 6.31445 8.99945 6.31445C9.74195 6.31445 10.4095 6.61445 10.897 7.10195Z",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3639 4.32687C12.0514 3.33687 10.5514 2.79688 8.99891 2.79688C6.35141 2.79688 3.88391 4.35687 2.16641 7.05687C1.49141 8.11437 1.49141 9.89188 2.16641 10.9494C2.75891 11.8794 3.44891 12.6819 4.19891 13.3269",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31445 14.6473C7.16945 15.0073 8.07695 15.2023 8.99945 15.2023C11.647 15.2023 14.1145 13.6423 15.832 10.9423C16.507 9.88477 16.507 8.10727 15.832 7.04977C15.5845 6.65977 15.3145 6.29227 15.037 5.94727",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6326 9.52344C11.4376 10.5809 10.5751 11.4434 9.51758 11.6384",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1025 10.8965L1.5 16.499",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5009 1.5L10.8984 7.1025",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCloseIcon);
export default __webpack_public_path__ + "static/media/passwordCloseIcon.672be317.svg";
export { ForwardRef as ReactComponent };